export default {
  title: 'Parking Payment',
  checked_in_at: 'Checked in at {{time}}',
  checked_in_subtitle: 'Park and exit when ready.',
  tap_to_refresh: 'Tap to check status',
  scan_qr_to_pay: 'Scan to pay',
  scan_dynamic_qr: 'Scan to pay with PromptPay',
  reference_label: 'Reference',
  charge_amount: 'Amount: ฿{{amount}}',
  upload_slip: 'Upload payment slip',
  tap_to_upload: 'Tap to select slip image',
  submit_slip: 'Submit Slip',
  waiting_title: 'Slip submitted',
  waiting_subtitle: 'Checking your slip. This page updates automatically.',
  upload_new_slip: 'Upload a new slip',
  rejected_title: 'Slip not accepted',
  rejected_reason: 'Reason: {{reason}}',
  rejected_plate: 'Plate {{plate}}',
  rejected_resubmit: 'Send a new slip',
  rejected_contact_staff: 'Or contact staff at the guard booth',
  contact_staff_title: 'Please contact the staff at the guard booth',
  contact_staff_subtitle: 'A staff member will help you pay for your parking.',
  overstay_title: 'Please contact staff to check out',
  overstay_subtitle: 'Your vehicle has been parked past the automatic payment window. A staff member will help you pay.',
  paid_title: 'Payment Verified',
  paid_subtitle: 'Verified at {{time}}. Drive safely!',
  errors: {
    invalid_token: 'Invalid or expired payment link.',
    load_failed: 'Failed to load session. Please try again.',
    upload_failed: 'Upload failed. Please try again.',
    no_file: 'Please select an image.',
  },
}
